import apiClient from './axiosInstanceStock';

export const getStockById = async (id) => {
  if (!id) {
    throw new Error("Stock ID is required");
  }
  return await apiClient.get(`/stockdetails/${id}`);
};
